import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { StoreUtmParametersInterface } from 'modules/contacts/types/contact-filter-interface'
import useUser from 'shared/hooks/use-user'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

export function useNeedShowUtmParameters() {
  const { user } = useUser()
  const { data } = useSWR<StoreUtmParametersInterface>(() => {
    if (!user) return

    return `${CONTACT_API}/bulk-actions/options`
  }, baseFetcher)
  if (data) return data.storeUtmData
}
